import { BaseTable } from '@/modules';
import { useSensorsTable } from '@/hooks/AssetsPreviewPage/shared/useSensorsTable';
import { sortSensors } from '@/utils/shared/sensorUtils';
import { Spinner } from '@/components';
import React, { useEffect } from 'react';
import { useLazyGetSensorsPreviewQuery } from '@/store/api/diagnosticApi';

interface sensorsModalProps {
  assetId: string;
  siteId: string;
}

export const SensorModal = ({ assetId, siteId }: sensorsModalProps) => {
  const [fetchSensorsPreview, { data: sensorsData, isLoading }] = useLazyGetSensorsPreviewQuery();
  const assetSensors = sensorsData?.[assetId] || [];
  const sortedSensors = assetSensors?.length ? sortSensors(assetSensors) : [];
  const { tableStructure } = useSensorsTable();

  useEffect(() => {
    fetchSensorsPreview({
      assetId,
      siteId,
    });
  }, []);

  return (
    <div className="flex flex-col h-full max-h-[calc(80vh-100px)]">
      {isLoading && (
        <div className="min-h-[400px] flex justify-center items-center">
          <Spinner size="large" />
        </div>
      )}
      {!isLoading && !sortedSensors?.length && <div className="min-h-[400px] pt-4">No data</div>}
      {!isLoading && !!sortedSensors?.length && (
        <BaseTable
          classNames={{
            card: {
              container: 'overflow-visible py-2 flex-1 flex flex-col',
            },
            table: {
              container: 'flex-1 overflow-auto',
              td: 'w-full text-left w-fit px-4 py-4 [&>*]:justify-start text-md',
              th: '[&>*]:justify-start px-2 py-2 w-fit',
            },
          }}
          data={sortedSensors || []}
          columns={tableStructure}
          enableSorting={true}
          enableSearch={true}
        />
      )}
    </div>
  );
};
